






import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

@Component
export default class SliderArrow extends Vue {
  @Prop()
  rightArrow: boolean;

  @Prop()
  onClick: () => void;

  @Prop()
  classes: string[];
}
